var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayButton = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 99,
    viewBox: "0 0 140 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.591 21.3144C138.591 21.3144 137.227 11.6342 133.022 7.36685C127.7 1.77433 121.728 1.75187 119 1.41497C99.409 2.67743e-07 70.0224 0 70.0224 0H69.9553C69.9553 0 40.5687 2.67743e-07 20.9776 1.41497C18.2492 1.75187 12.278 1.77433 6.95527 7.36685C2.7508 11.6342 1.38658 21.3144 1.38658 21.3144C1.38658 21.3144 -2.66602e-08 32.6791 -2.66602e-08 44.0663V54.7348C-2.66602e-08 66.0995 1.40895 77.4642 1.40895 77.4642C1.40895 77.4642 2.77316 87.1444 6.97764 91.4118C12.3003 97.0043 19.3003 96.8246 22.4089 97.4086C33.5911 98.4866 70 98.8235 70 98.8235C70 98.8235 99.409 98.7786 119 97.3636C121.728 97.0267 127.7 97.0043 133.022 91.4118C137.227 87.1444 138.591 77.4642 138.591 77.4642C138.591 77.4642 140 66.0995 140 54.7348V44.0663C140 32.6791 138.591 21.3144 138.591 21.3144Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5532 28.1422V67.6267L93.3711 47.9518L55.5532 28.1422Z",
    fill: "#EAEAEA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PlayButton.be763efb3ce25cd2ed9faeb08b30058c.svg";